import { Hamburger } from "phosphor-react";
import { Link } from "react-router-dom";
import { ROUTES } from "../config";

function NavBar() {
  const pathname = window.location.pathname;
  return (
    <div className="navbar">
      <div className="navbar-header">
        <Hamburger size={32} /> <span>Ham vs. Burger</span>
      </div>
      <ul className="navbar-links">
        <li
          className={
            "" + pathname === ROUTES.home ? "navbar-active" : "navbar-inactive"
          }
        >
          <Link to={ROUTES.home}>Home</Link>
        </li>
        <li
          className={
            "" + pathname === ROUTES.leaderboard
              ? "navbar-active"
              : "navbar-inactive"
          }
        >
          <Link to={ROUTES.leaderboard}>Leaderboard</Link>
        </li>
      </ul>
    </div>
  );
}

export default NavBar;
